//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Dialog} from 'vant';
import {formatDate} from "../../lib/date";
import {getRoomsByMemberId, relieveMemberFamilyEntity} from '../../api/newOwner'

export default {
  name: "my-houses",
  data() {
    return {
      show: false,
      leftIco: require('@/assets/img/ico-building.png'),
      list: [],
      memberInfo: {},
      showUnbindOwner: false,
      ownerId: 0,
      index: '',
      selectedRoomId: 0
    }
  },
  filters: {
    // formatDate(time, type) {
    //     var date = new Date(time);
    //     if (type == 1) {
    //         return formatDate(date, 'yyyy/MM/dd');
    //     }
    //     return formatDate(date, 'yyyy-MM-dd hh:mm');
    // }
  },
  methods: {
    unsetBind() {
      Dialog.confirm({
        title: '',
        message: '确定要重新认证？',
      }).then(() => {
        //点击确定按钮时做什么？
        this.$router.push({
          name: 'character',
        });
      }).catch(() => {
        // on cancel
      });
    },
    getOwners() {
      getRoomsByMemberId(parseInt(this.memberInfo.id)).then(res => {
        this.list = [];
        this.list.push(...res.data.result);
      }).finally(() => {
      });
    },
    async getMyMember() {
      this.$toast.loading({
        duration: 0,
        message: ''
      });
      await this.$store.dispatch({
        type: 'member/getMyMember'
      }).then(() => {
        this.memberInfo = {};
        this.memberInfo = this.$store.state.member.memberInfo;
        this.getOwners();

      }).finally(() => {
        this.$toast.clear();
      });
    },
    showUnbindOwnerEdit(row) {
      // this.ownerId = row.id;
      this.selectedRoomId = row.id
      this.showUnbindOwner = true;
    },
    unbindOwner() {
      // if (this.ownerId === 0) {
      //     return
      // }
      // abp.ajax.post('/api/services/app/Owner/UnbindOwner?id=' + this.ownerId).then(res => {
      const page = {memberId: this.memberInfo.id, roomId: this.selectedRoomId};
      // console.log(page);
      // return;
      relieveMemberFamilyEntity(page).then(res => {
        this.$toast.success("解绑成功")
        this.init();
        // this.totalCount = res.data.result.totalCount;
      }).finally(() => {
        // this.loading = false;
      });
    },
    init() {
      this.getMyMember();
    },
    houseDetail(row) {
      this.$router.push({
        name: 'house-detail',
        params: {
          roomId: row.id
        }
      })
    },

    pcDownLoad(rId) {
      // this.$router.push({name:'activeDetail',params:{id:id}});
      this.$router.push({
        name: 'pc-download',
        params: {
          roomOwnerId: rId,
        }
      })
    }
  },
  created() {
    this.getMyMember();
  }
}
